import { useTracking } from '@packages/tracking/src/hooks/useTracking/useTracking';
import type { GTMEventGlycerinLinkClick } from '@packages/tracking/src/types/events';

export const useArticleServicesTracking = () => {
  const dispatchTracking = useTracking();

  const trackingGlycerinLinkClick = ({
    category,
    detail,
  }: Pick<GTMEventGlycerinLinkClick['LinkClickData'], 'category' | 'detail'>) => {
    dispatchTracking<GTMEventGlycerinLinkClick>({
      event: 'LinkClick',
      LinkClickData: {
        category,
        detail,
        label: 'APlus Service',
      },
    });
  };

  return { trackingGlycerinLinkClick };
};
